import { CSCQ_SELECT_OPTION, CSCQ_SUBMIT } from "../../Redux.constants";
import { selectOption } from "./SelectOption";
import { submitAnswer } from "./SubmitAnswer";

export function CSCQReducer(state = {}, action) {
  switch (action.type) {
    case CSCQ_SELECT_OPTION:
      return selectOption(state, action.payload);
    case CSCQ_SUBMIT:
      return submitAnswer(state, action.payload);
    default:
      return state;
  }
}
